import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiToyGeneratorConfig } from '@/data/landingConfig/landingAiToyGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiToyGenerator } from './schemaObject';

interface Props {}
const AiToyGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiToyGenerator} />
			<LandingTemplate
				data={landingAiToyGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiToyGenerator;
